import { CustomersApiRemoteService } from '../../Services/api/customers/customers-service'
import { ICustomerListResponse, IListCustomersPayload } from '../../Services/api/customers/customers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListCustomersUseCase
implements IFormUsecase<IListCustomersPayload, ICustomerListResponse> {
  constructor (private readonly CustomersApi: CustomersApiRemoteService) {}
    

  public async handle (
    data: IListCustomersPayload
  ): Promise<Result<ICustomerListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CustomersApi.list(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
